import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

class BusinessService {
  getMyBusiness() {
    return axios
      .get(API_URL + "businesses/mine", { headers: authHeader() })
      .then((response) => response.data);
  }

  getBusiness(id) {
    return axios
      .get(API_URL + "businesses/" + id, { headers: authHeader() })
      .then((response) => response.data);
  }

  getOrders(businessId) {
    return axios
      .get(API_URL + "businesses/" + businessId + "/orders", {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  getAnalytics(businessId) {
    return axios
      .get(API_URL + "businesses/" + businessId + "/analytics", {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  regenerateApiKey(id) {
    return axios
      .post(API_URL + "businesses/" + id + "/regenerate_api_key", {}, { headers: authHeader() })
      .then((response) => response.data);
  }

  update(id, data) {
    return axios
      .put(API_URL + "businesses/" + id, data, { headers: authHeader() })
      .then((response) => response.data);
  }
}

export default new BusinessService();
